import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Css/AddQueForm.css';
import axios from "axios";
import API_BASE from "../config/api";

const AddQuestionForm = ({ questionData, onSave, onCancel }) => {
  const [question, setQuestion] = useState('');
  const [answers, setAnswers] = useState(['', '', '', '']);
  const [answerImages, setAnswerImages] = useState([null, null, null, null]);
  const [correctIndex, setCorrectIndex] = useState(null);
  const [explanation, setExplanation] = useState('');
  const [questionImage, setQuestionImage] = useState(null);
  const navigate = useNavigate();
  const [explanationImage, setExplanationImage] = useState(null);
  const [softwares, setSoftwares] = useState([]);
  const [topics, setTopics] = useState([]);
const [subTopics, setSubTopics] = useState([]);
const [paperTypeId, setPaperTypeId] = useState('');


  const [standards, setStandards] = useState([]);
  const [subjects, setSubjects] = useState([]);
const [paperTypes, setPaperTypes] = useState([]);
const [answerTypes, setAnswerTypes] = useState([]);
  const [difficulty, setDifficulty] = useState("");
const [answerTypeId, setAnswerTypeId] = useState('');
const [difficultyId, setDifficultyId] = useState('');

  const [softwareId, setSoftwareId] = useState('');
  const [standardId, setStandardId] = useState('');
  const [subjectId, setSubjectId] = useState('');
  const [dropdown1, setDropdown1] = useState('');
  const [dropdown2, setDropdown2] = useState('');

  useEffect(() => {
    if (questionData) {
      setQuestion(questionData.question || '');
      const initialOptions = questionData.options?.slice(0, 4) || ['', '', '', ''];
      setAnswers(initialOptions);
      const correctIdx = initialOptions.findIndex(opt => opt === questionData.answer);
      setCorrectIndex(correctIdx !== -1 ? correctIdx : null);
      setExplanation(questionData.explanation || '');
      setQuestionImage(questionData.questionImage || null);
      setAnswerImages(questionData.answerImages || [null, null, null, null]);
    }
  }, [questionData]);

  const handleAnswerChange = (index, value) => {
    const updated = [...answers];
    updated[index] = value;
    setAnswers(updated);
  };
  const handleExplanationImageChange = (file) => {
    setExplanationImage(file);
  };
 useEffect(() => {
  axios
    .get(`${API_BASE}/api/questions/dropdowns`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((res) => {
      console.log("DROPDOWN RESPONSE", res.data);

      setSoftwares(res.data.softwares || []);
      setStandards(res.data.standards || []);
      setSubjects(res.data.subjects || []);
      setPaperTypes(res.data.paperTypes || []);
    })
    .catch((err) => {
      console.error(err);
    });
}, []);

useEffect(() => {
  const fetchExtraDropdowns = async () => {
    try {
      const token = localStorage.getItem("token");

      const answerRes = await axios.get(
        `${API_BASE}/api/questions/answer-types`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setAnswerTypes(answerRes.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  fetchExtraDropdowns();
}, []);



  const handleSoftwareChange = async (id) => {
    setSoftwareId(id);

    const res = await axios.get(
      `${API_BASE}/api/questions/dropdowns?softwareId=${id}`,
      { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
    );

    setStandards(res.data.standards);
  };

 const handleStandardChange = async (id) => {
  setStandardId(id);

  const res = await axios.get(
    `${API_BASE}/api/questions/dropdowns?softwareId=${softwareId}&standardId=${id}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }
  );

  setSubjects(res.data.subjects || []);
};


  const handleAnswerImageChange = (index, file) => {
    const updatedImages = [...answerImages];
    updatedImages[index] = file;
    setAnswerImages(updatedImages);
  };

  const handleQuestionImageChange = (file) => {
    setQuestionImage(file);
  };

  const handleSave = async () => {
  if (correctIndex === null) {
    alert("Correct answer select kara");
    return;
  }

  const payload = {
  softwareId: Number(softwareId),
  subjectId: Number(subjectId),

  answerTypeId: Number(answerTypeId),
  difficultyLevelId: Number(difficultyId),
   paperTypeId: Number(paperTypeId),

  questionText: question,
  topic: dropdown1,
  subTopic: dropdown2,

  optionA: answers[0],
  optionB: answers[1],
  optionC: answers[2],
  optionD: answers[3],

  correctAnswer: ["A", "B", "C", "D"][correctIndex],

  explanation: explanation,
  mark: 1
};


  await axios.post(
    `${API_BASE}/api/questions/create-question`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json"
      }
    }
  );

  alert("Question added successfully");
  navigate("/dashboard/quemanagment");
};

const handleSubjectChange = async (id) => {
  const subjectIdNumber = Number(id);
  setSubjectId(subjectIdNumber);

  console.log("Sending subjectId:", subjectIdNumber);

  const res = await axios.get(
    `${API_BASE}/api/questions/topics/${subjectIdNumber}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );

  console.log("TOPIC RESPONSE:", res.data);
 setTopics(res.data || []);

};

const handleChapterChange = async (e) => {
  const topic = e.target.value;
  setDropdown1(topic); // topic save kara

  try {
    const response = await axios.get(
      `${API_BASE}/api/questions/subtopics?subjectId=${subjectId}&topic=${topic}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    setSubTopics(response.data || []);
  } catch (error) {
    console.error(error);
  }
};


  return (
    <div className="question-form-container">
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          प्रश्न संच   &gt;&gt; <span>प्रश्न मजकूर जोडा </span>
        </h3>
        <div className="edit-btnn">
          <button className="btn outlinee" onClick={() => navigate(-1)}>
            रद्द करा
          </button>
        <button className="btn primaryy" onClick={handleSave}>
  सेव्ह करा
</button>
        </div>
      </div>
      <div className='question-form-header'>
        <h2>प्रश्न मजकूर जोडा </h2>
      </div>
      <div className="dropdown-row">
        <div className="dropdown-line">
          <select onChange={(e) => handleSoftwareChange(e.target.value)}>
            <option value="">परीक्षेचे नाव</option>
           {softwares.map(s => (
  <option key={s.id} value={s.id}>{s.name}</option>
))}
          </select>
          <select
  value={paperTypeId}
  onChange={(e) => setPaperTypeId(e.target.value)}
>
  <option value="">परीक्षा प्रकार</option>
  {paperTypes.map(p => (
    <option key={p.id} value={p.id}>{p.name}</option>
  ))}
</select>


          <select onChange={(e) => handleStandardChange(e.target.value)}>
            <option value="">इयत्ता</option>
            {standards.map(s => (
              <option key={s.id} value={s.id}>{s.name}</option>
            ))}
          </select>

<select onChange={(e) => handleSubjectChange(e.target.value)}>
            <option value="">विषय</option>
            {subjects.map(s => (
              <option key={s.id} value={s.id}>{s.name}</option>
            ))}
          </select>
        </div>

        <div className="dropdown-line">
<select
  onChange={handleChapterChange}
>
  <option value="">घटक</option>
  {topics.map((topic, index) => (
    <option key={index} value={topic}>
      {topic}
    </option>
  ))}
</select>

<select
  onChange={(e) => setDropdown2(e.target.value)}
>
  <option value="">उपघटक</option>
  {subTopics.map((sub, index) => (
    <option key={index} value={sub}>
      {sub}
    </option>
  ))}
</select>
<select
  value={answerTypeId}
  onChange={(e) => setAnswerTypeId(e.target.value)}
>
  <option value="">उत्तर निवड प्रकार</option>
  {answerTypes.map((type) => (
    <option key={type.id} value={type.id}>
      {type.name}
    </option>
  ))}
</select>

 <select onChange={e => setDifficulty(e.target.value)}>
            <option>प्रश्न पातळी</option>
            <option>Easy</option>
            <option>Moderate</option>
            <option>Difficult</option>
          </select>

        </div>
      </div>

      <div className='question-form-header'>
        <label className="question-label">प्रश्न</label>
        <button className='para-btn' onClick={() => navigate('/dashboard/addpara')}>परिच्छेद प्रश्न</button>
      </div>
      <div className="answer-row">
        <input
          className="answer-input"
          placeholder="प्रश्न इथे टाका "
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
        />
        <label className="add-image-link">
          Add Image
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleQuestionImageChange(e.target.files[0])}
          />
        </label>
      </div>
      {questionImage && (
        <img
          src={URL.createObjectURL(questionImage)}
          alt="Question Preview"
          className="image-preview"
        />
      )}

      <label className="question-label">उत्तर पर्याय लिहा </label>
      <p className="sub-label">बरोबर पर्याय चिन्हांकित करा</p>

      {answers.map((answer, index) => (
        <div key={index}>
          <label className="option-label">{`पर्याय 0${index + 1}`}</label>
          <div className="answer-block">
            <input
              type="checkbox"
              name="correctAnswer"
              checked={correctIndex === index}
              onChange={() => setCorrectIndex(index)}
              className="option-radio"
            />
            <div className="answer-row">
              <input
                type="text"
                className="answer-input"
                placeholder={`पर्याय ०${index + 1} लिहा`}
                value={answer}
                onChange={(e) => handleAnswerChange(index, e.target.value)}
              />

              <label className="add-image-link">
                Add Image
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleAnswerImageChange(index, e.target.files[0])}
                />
              </label>
            </div>

            {answerImages[index] && (
              <img
                src={URL.createObjectURL(answerImages[index])}
                alt={`Option ${index + 1}`}
                className="image-preview"
              />
            )}
          </div>
        </div>
      ))}
      <div className="explain">
        <label className="question-label">स्पष्टीकरण</label>

        <div className="explanation-wrapper">
          <textarea
            className="explanation-input"
            placeholder="इथे स्पष्टीकरण लिहा"
            value={explanation}
            onChange={(e) => setExplanation(e.target.value)}
            rows="4"
          />

          <label className="add-image-inside">
            Add Image
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={(e) =>
                handleExplanationImageChange(e.target.files[0])
              }
            />
          </label>
        </div>

        {explanationImage && (
          <img
            src={URL.createObjectURL(explanationImage)}
            alt="Explanation Preview"
            className="image-preview"
          />
        )}
      </div>


    </div>
  );
};

export default AddQuestionForm;
